import React, {useEffect, useState} from 'react';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem/PaginationItem';
import { ReactComponent as ArrayLeftIcon } from '../../assets/main/groups/main-table/array-left.svg';
import { ReactComponent as ArrayRightIcon } from '../../assets/main/groups/main-table/array-right.svg';

interface CustomPaginationProps {
    pageCount: number;
    currentPage?: number;
    onChangeHandle: (event: React.ChangeEvent<unknown>, value: number) => void;
}

export const CustomPagination: React.FC<CustomPaginationProps> = ({ pageCount, currentPage, onChangeHandle }) => {
    const [siblingCount, setSiblingCount] = useState<number>(2);

    useEffect(() => {
        const handleResize = () => {
            setSiblingCount(window.innerWidth < 960 ? -1 : 2);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Pagination
            className="pager"
            count={pageCount}
            page={currentPage}
            siblingCount={siblingCount}
            boundaryCount={1}
            onChange={onChangeHandle}
            renderItem={(item) => (
                <PaginationItem
                    slots={{ previous: ArrayLeftIcon, next: ArrayRightIcon }}
                    {...item}
                />
            )}
        />
    );
};
